import type { InputHTMLAttributes, ReactNode } from "react";
import clsx from "clsx";
import { CheckboxColor, CheckboxProps } from "../types";

const checkboxColorClasses: Record<CheckboxColor, string> = {
  green: "accent-green-600 focus:ring-green-600",
  blue: "accent-blue-600 focus:ring-blue-600",
};

export function Checkbox({
  color = "green",
  label,
  className,
  labelClassName,
  wrapperClassName,
  disabled,
  ...props
}: CheckboxProps) {
  const input = (
    <input
      {...props}
      type="checkbox"
      disabled={disabled}
      className={clsx(
        "h-4 w-4 rounded border-theme-border-strong cursor-pointer focus:none disabled:cursor-not-allowed",
        checkboxColorClasses[color],
        disabled && "opacity-60",
        className
      )}
    />
  );

  if (!label) {
    return input;
  }

  return (
    <label
      className={clsx(
        "flex items-center gap-2 text-sm cursor-pointer",
        disabled && "cursor-not-allowed opacity-60",
        wrapperClassName
      )}
    >
      {input}
      <span className={labelClassName}>{label}</span>
    </label>
  );
}
